import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { MaterialIcon } from '@pearsontechnology/aero-components';
import Link from 'data/Link';
import ComponentsBreadcrumbs from 'components/Breadcrumbs';
import BackButton from '../ManualGradingReviewComponents/BackButton';
import ManualGradingComponentPopper from '../ManualGradingComponentPopper';
import { NavbarLeft, ComponentTitleButton } from '../ManualGradingReviewComponents/Navbar';
import { INTERACTIVE } from '../../constants';
import { useTitledAncestors } from './useTitledAncestors';

const Breadcrumbs = ({
  parentConfiguration: { title: parentTitle },
  componentConfiguration: { title: componentTitle },
  studentId,
  cohortId,
  deploymentId,
  ancestry,
  ...component
}) => {
  const ancestors = useTitledAncestors({ cohortId, deploymentId, ancestry });
  const [popper, setPopper] = useState({ selectedEl: null, isPopperOpen: false });
  const parentRoute = `/classes/${cohortId}/grades/${deploymentId}/grades/`;
  const onClickComponentSelect = ({ currentTarget }) => {
    setPopper({
      isPopperOpen: true,
      selectedEl: currentTarget,
    });
  };

  const closePopper = () => {
    setPopper({ isPopperOpen: false });
  };

  return (
    <NavbarLeft>
      <BackButton route={parentRoute} />
      <ComponentsBreadcrumbs
        links={[
          ...ancestors.map(({ elementId, title }) => !title ? new Link('') : new Link(`${parentRoute}${elementId}`, title)),
          new Link('#', parentTitle),
        ]}
      />
      <ComponentTitleButton
        grey
        iconRight
        onClick={onClickComponentSelect}
      >
        {componentTitle}
        <MaterialIcon id="arrow_drop_down" />
      </ComponentTitleButton>
      <ManualGradingComponentPopper
        el={popper.selectedEl}
        show={popper.isPopperOpen}
        onClose={closePopper}
        cohortId={cohortId}
        deploymentId={deploymentId}
        walkableId={component.parentId}
        walkableType={INTERACTIVE}
        componentId={component.componentId}
        studentId={studentId}
      />
    </NavbarLeft>
  );
};

Breadcrumbs.propTypes = {
  cohortId: PropTypes.string.isRequired,
  deploymentId: PropTypes.string.isRequired,
  parentConfiguration: PropTypes.shape({ title: PropTypes.string }),
  componentConfiguration: PropTypes.shape({ title: PropTypes.string }),
  studentId: PropTypes.string.isRequired,
  ancestry: PropTypes.array,
};

export default Breadcrumbs;
